var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M72.5,57.432l-6.07-6.069c-1.402-1.404-3.853-1.403-5.253-0.001l-4.08,4.079c-1.651-0.531-5.399-2.138-9.899-6.638 c-4.506-4.507-6.11-8.258-6.639-9.898l4.081-4.081c0.702-0.701,1.088-1.634,1.088-2.626c0-0.992-0.386-1.925-1.088-2.626 L38.568,23.5c-1.447-1.447-3.803-1.448-5.252,0l-4.886,4.885c-0.279,0.279-2.72,2.873-2.529,7.978 c0.237,6.334,4.367,13.554,12.274,21.461c9.814,9.814,17.138,12.288,22.027,12.288c4.76,0,7.214-2.346,7.412-2.544l4.887-4.886 C73.947,61.236,73.947,58.88,72.5,57.432z M64.812,64.717c-0.073,0.068-7.497,6.592-23.809-9.72 c-16.121-16.121-9.939-23.558-9.725-23.803l4.664-4.664l5.667,5.667l-4.683,4.683c-0.444,0.444-0.654,1.07-0.566,1.692 c0.034,0.24,0.906,5.953,8.01,13.058c7.104,7.104,12.818,7.977,13.058,8.01c0.624,0.084,1.247-0.123,1.691-0.566l4.684-4.683 l5.667,5.667L64.812,64.717z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.0aba2568f17e12663d5f69f16689be70.svg";
export { ForwardRef as ReactComponent };